import {useTranslation} from 'react-i18next'

export default function MaxCharactersNote({characters}: any) {
  const {t} = useTranslation()
  return (
    <>
      {characters && (
        <span style={{color: '#939393', fontSize: '10px', margin: '0 5px'}}>
          ( {t('noteMaxCaracter')} {characters} {t('characters')} )
        </span>
      )}{' '}
    </>
  )
}
